import { combineReducers, configureStore } from "@reduxjs/toolkit";
import { persistReducer, persistStore } from "redux-persist";
import storage from "redux-persist/lib/storage";
import thunk from "redux-thunk";
import articleSlice from "./article/article";
import bannerSlice from "./banner/banner";
import changePointCustomerSlice from "./changePoint/changePointCustomer";
import changePointSettingSlice from "./changePoint/changePointSetting";
import customerType from "./customer/customerType/customerType";
import groupCustomer from "./customer/groupCustomer/groupCustomer";
import listAddress from "./customer/listAddress";
import rankCustomer from "./customer/rankCustomer/rankCustomer";
import redeemDisCountCustomer from "./customer/redeemDisCount/redeemDisCountCustomer";
import customerSee from "./customerSee/customerSee";
import storeCustomer from "./customerSee/storeCustomer";
import dashboard from "./dashboard/dashboard";
import dashboardAdmin from "./dashboard/dashboardAdmin";
import dataGiftSlice from "./giftExchange/dataGift";
import giftExchangeSlice from "./giftExchange/giftExchange";
import giftExchangeForCusActiveSlice from "./giftExchange/giftExchangeForCusActive";
import giftExchangeForCusHistorySlice from "./giftExchange/giftExchangeForCusHistories";
import telcoDataGiftSlice from "./giftExchange/telcoDataGift";
import globalflag from "./globalflag/globalflag";
import mapServiceBranchSlice from "./mapServiceBranch/mapServiceBranch";
import getListProgramCoupon from "./mcoupon/getListProgramCoupon";
import pointMechanismsSlice from "./pointMechanisms/pointMechanisms";
import rewardDataGwSlice from "./rewardDataGw/rewardDataGw";
import surveyResponsesSlice from "./rewardDataGw/surveyResponses";
import rewardTypeSlice from "./rewardType/rewardType";
import servicesSlice from "./serviceProject/service";
import sms from "./smsConfig/sms";
import employeeManager from "./staff/employeeManager";
import suspensionPointSettingSlice from "./suspensionPointSetting/suspensionPointSetting";
import templateSlice from "./template/template";
import trade from "./trade/trade";
import trademarkSlice from "./trademark/trademark";
import trademarkCompanyMapSlice from "./trademark/trademarkCompanyMap";
import voucherRedux from "./voucher/voucherRedux";
import zaloEventSlice from "./zaloEvent/zaloEvent";
import znsEventSlice from "./znsEvent/znsEvent";
import znsEventBranchMapSlice from "./znsEvent/znsEventBranchMap";
const persistConfig = {
  key: "data",
  storage,
  whitelist: ["dashboard"],
};
export const rootReducers = combineReducers({
  getListProgramCoupon,
  employeeManager,
  listAddress,
  customerType,
  rankCustomer,
  storeCustomer,
  voucherRedux,
  sms,
  trade,
  groupCustomer,
  customerSee,
  dashboard,
  redeemDisCountCustomer,
  globalflag,
  servicesSlice, // ADD reducer mới ntao vào root reduce
  rewardTypeSlice,
  pointMechanismsSlice,
  zaloEventSlice,
  trademarkSlice,
  trademarkCompanyMapSlice,
  znsEventSlice,
  znsEventBranchMapSlice,
  changePointCustomerSlice,
  changePointSettingSlice,
  suspensionPointSettingSlice,
  giftExchangeSlice,
  dataGiftSlice,
  telcoDataGiftSlice,
  giftExchangeForCusHistorySlice,
  giftExchangeForCusActiveSlice,
  mapServiceBranchSlice,
  dashboardAdmin,
  rewardDataGwSlice,
  surveyResponsesSlice,
  bannerSlice,
  articleSlice,
  templateSlice,
});
const persistedReducer = persistReducer(persistConfig, rootReducers);
export const store = configureStore({
  reducer: { persistedReducer }, // store nhận vào 1 reducer
  middleware: [thunk],
  devTools: process.env.NODE_ENV !== "production",
});
export const persistor = persistStore(store);
